import * as yup from "yup";
import { isHrIbanValid } from "ui/components/TextField/IbanTextField/ibanUtils";

export const TENANT_BANK_ACCOUNT_EDIT_FORM_SCHEMA = yup.object().shape({
  iban: yup
    .string()
    .required("Molimo unesite IBAN")
    .test("iban-valid", "Neispravan IBAN", (value) => isHrIbanValid(value ?? "")),
});
